import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=56a8b99c&scoped=true"
import script from "./Address.vue?vue&type=script&lang=ts"
export * from "./Address.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a8b99c",
  null
  
)

export default component.exports